export default {"src":"/_next/static/media/mtl.95befa65.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};